import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BRAND } from '~global-constants/brand';

@Component({
  selector: 'app-signup-page-complete',
  templateUrl: './signup-complete.component.html',
  imports: [RouterLink],
})
export class SignupCompleteComponent implements OnInit {
  readonly brand = BRAND;
  constructor() {}

  ngOnInit(): void {}
}
